// Used as vuex store module path
const WEBLINKS_ID = 'weblinks';
export default WEBLINKS_ID;
